import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Solutions() {
  const blocks = useBlockRenderer('solutions') as Block[]
  return <BlockRenderer blocks={blocks} />
}
